import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FeatureHero } from '../../../../widgets/feature-hero/feature-hero';
import { FeatureRow } from '../../../../widgets/feature-row/feature-row';

@Component({
  selector: 'app-msp-Solution',
  templateUrl: './page.html',
  styleUrl: './page.scss',
  standalone: true,
  imports: [RouterModule, FeatureHero, FeatureRow],
})
export class MSPSolution {
  whatIsParagraphs = ["A Service Desk is a software solution for MSPs that is a central point of contact between an MSP and its customers. It is responsible for managing customer inquiries, providing support and troubleshooting, and escalating issues to appropriate MSP staff. The service desk is typically staffed by customer service representatives who are trained to handle customer inquiries and support issues."];

  whatDoesItDoParagraphs = ["Infraon's Service desk for MSPs is a cloud-based help desk solution that enables MSPs to provide their customers with 24/7 support. The solution includes a ticketing system, a knowledge base, and a self-service portal. The service desk is responsible for handling customer inquiries and providing support for products and services. MSPs can use our Service Desk to manage customer support requests and resolve technical issues. They can also use the solution to monitor their customers' networks and infrastructure."];

  constructor() {}

}